"use client";

import * as React from "react";

import { IRoutingContext } from "./types";

export const RoutingContext: React.Context<IRoutingContext> =
  React.createContext({
    locale: undefined,
    canonicalLocale: "en-US",
    localeCountryUrlPrefix: "",
    robotLocalePrefix: undefined,
    // TODO: Remove the faireDirect related fields
    // once FAIRE_DIRECT_SIGNUP_PHASE_2_250705 is enabled for all users
    faireDirectBrandAlias: undefined,
    faireDirectBrandToken: undefined,
    faireDirectWidgetToken: undefined,
    Link: undefined,
    useSearchParams: undefined,
    useRouterOrHistory: undefined,
    usePathname: undefined,
    getShouldUseSoftNavigation: undefined,
  } as IRoutingContext);
